'use strict';

module.exports = inlineHeaders;

var encode = require('querystring-es3/encode');

function inlineHeaders(url, headers) {
  if (/\?/.test(url)) {
    url += '&';
  } else {
    url += '?';
  }

  return url + encode(headers);
}



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/browser/inline-headers.js
// module id = 537
// module chunks = 168707334958949